import React from 'react'
import InputAdornment from '@material-ui/core/InputAdornment'
import _ from 'lodash'
import * as Colors from '../../../../src/common/colors'

export const useTextField = ({actionSecondary, iconSecondary: IconSecondary, ...props}, classes) => {

    const buttonState = _.cloneDeep(props)
    buttonState.className = classes.inputBase
    buttonState.showLabelOptional = undefined
    
    buttonState.labelInside = undefined
    if (!props?.labelInside) {
        buttonState.label = undefined
    }
    if (props?.labelInside && props?.showLabelOptional) {
        buttonState.label = `${buttonState.label} (opcional)`
    }
    buttonState.InputProps = {}
    if (props?.readOnly) {
        buttonState.InputProps = { ...buttonState.InputProps, readOnly: true }
        buttonState.className = classes.readOnly
        buttonState.readOnly = undefined
        buttonState.error = undefined
    }
    if (props?.icon) {
      const style = {
        fontSize: 24
      }
      const styleIconSecondary = {
          ...style,
          borderRight: '1px solid ' + Colors.COLOR_TEXT_EXTRA_LIGHT,
          paddingRight: '5px',
          marginRight: '-5px',
          marginLeft: '-6px',
          cursor: 'pointer',
          boxSizing: 'content-box',
          width: '20px',
      }

      buttonState.InputProps = {
        ...buttonState.InputProps,
        endAdornment: (
          <>
            {IconSecondary &&  
              <InputAdornment position="end" onClick={actionSecondary}>
                {!buttonState.InputProps?.readOnly && <IconSecondary style={styleIconSecondary}></IconSecondary>}
              </InputAdornment>}
            <InputAdornment position="end">
              {!buttonState.InputProps?.readOnly && <props.icon style={style}></props.icon>}
            </InputAdornment>
          </>
        )
      }

      buttonState.icon = undefined
    } else if (props?.prefix) {
        buttonState.InputProps = {
            ...buttonState.InputProps,
            startAdornment: (
                <InputAdornment position="start">
                    {props?.prefix}
                </InputAdornment>
            )
        }
    } else if (props?.suffix) {
        buttonState.InputProps = {
            ...buttonState.InputProps,
            inputProps: {
                style: {
                    textAlign: 'right'
                }
            },
            endAdornment: (
                <InputAdornment position="end">{props?.suffix}</InputAdornment>
            )
        }
    }
    buttonState.helperText = undefined

    if (props?.disabled && props?.error) {
        buttonState.error = undefined
    }
    props?.readOnly && delete buttonState.disabled
    if (props?.readOnly && props?.icon) {
        const { ...rest } = buttonState.InputProps
        buttonState.InputProps = { ...rest }
    }

    const labelOutsideState = {
        labelInside: props.labelInside,
        key: props.key,
        size: props.size,
        label: props.label,
        showLabelOptional: props.showLabelOptional,
    }

    const helperState = {
        helperText: props.helperText,
        size: props.size,
        error: buttonState.error,
        key: props.key,
        icon: props.icon, // agregado para control del minWidth, ver los otros
        prefix: props.prefix,
    }

    return { buttonState, labelOutsideState, helperState }
}